import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import { toast } from 'react-toastify';

import InfiniteCalendar, {
    Calendar,
    withRange,
} from 'react-infinite-calendar';

import 'react-infinite-calendar/styles.css';

import DiasFeriadosTable from './DiasFeriadosTable';

import { SaveFeriado, diasDisabled } from "../../funciones/PreferenciasAdminFunction";

class DiasFeriados extends Component {
    state = {
        selectDay: "",
        boton1: {
            icon: "fa fa-spinner fa-spin",
            text: "Espera",
            disabled: true
        },
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando fechas</React.Fragment>,
        diasAsig: [],
        diasDisabled: []
    }

    componentDidMount = () => {
        diasDisabled ((resp) => {
            let contenido = [];
            let pre = "";
            if (resp.length === 0 ) pre = <div>No existen dias No Laborables registrados</div>
            for (let i in resp){
                let date = resp[i].dia.split("/")
                let addDate = new Date(parseInt(date[2]), (parseInt(date[1]) - 1), parseInt(date[0]))
                contenido.push(addDate)
            }

            this.setState({
                diasDisabled: contenido,
                boton1: { icon: "fa fa-plus", text: "Agregar",  disabled: false },
                diasAsig: resp,
                preloader: pre
            })
        })
    }

    diaSelect = (rango) => {
        let dateIn = new Date(rango.start);
        let dayIn = dateIn.getDate();
        let monthIn = dateIn.getMonth() + 1;
        let yearIn = dateIn.getFullYear();

        if (dayIn < 10) dayIn = `0${dayIn}`
        if (monthIn < 10) monthIn = `0${monthIn}`

        let diaInF = `${dayIn}/${monthIn}/${yearIn}`;

        let dateOut = new Date(rango.end);
        let dayOut = dateOut.getDate();
        let monthOut = dateOut.getMonth() + 1;
        let yearOut = dateOut.getFullYear();

        if (dayOut < 10) dayOut = `0${dayOut}`
        if (monthOut < 10) monthOut = `0${monthOut}`
        
        let diaOutF = `${dayOut}/${monthOut}/${yearOut}`;

        document.getElementById("fechaInAdm").value = diaInF;
        document.getElementById("fechaOutAdm").value = diaOutF;
    }

    calendario = () => (
        <InfiniteCalendar
            Component={withRange(Calendar)}
            width="100%"
            height={250}
            disabledDays={this.props.DiasOff}
            locale={{
                locale: require('date-fns/locale/es'),
                headerFormat: 'D MMM',
                weekdays: ["Dom", "Lun", "Mar", "Mier", "Jue", "Vie", "Sab"],
                todayLabel: {
                    long: 'Hoy',
                    short: 'Hoy'
                }
            }}
            theme={{
                selectionColor: 'rgb(50, 165, 165)',
                textColor: {
                    default: '#333',
                    active: '#FFF'
                },
                weekdayColor: 'rgb(22, 115, 115)',
                headerColor: 'rgb(50, 165, 165)',
                floatingNav: {
                    background: 'rgba(16, 39, 39, 0.96)',
                    color: '#FFF',
                    chevron: 'rgba(255, 255, 255, 0)'
                }
            }}
            onSelect={(date) => { this.diaSelect(date) }}

            selected={{
                start: new Date(),
                end: new Date()
            }}

            disabledDates={this.state.diasDisabled}
        />
    )

    addDias = () => {
        let { boton1, preloader, diasAsig } = this.state;

        const styles = {
            padding: 2, fontSize: 12
        }

        let diasFeriadosAsig = () => {
            if (diasAsig.length === 0 ) return (
                <tr>
                    <td colSpan={3} align="center">{preloader}</td>
                </tr>
            )

            return (
                diasAsig.map(option => (
                    <DiasFeriadosTable key = {option.id} datos = {option}
                    delResp = {() => {
                        diasDisabled ((resp) => {
                            let pre = "";
                            if (resp.length === 0 ) pre = <div>No existen dias No Laborables registrados</div>

                            let contenido = [];
                            for (let i in resp){
                                let date = resp[i].dia.split("/")
                                let addDate = new Date(parseInt(date[2]), (parseInt(date[1]) - 1), parseInt(date[0]))
                                contenido.push(addDate)
                            }
                
                            this.setState({
                                diasDisabled: contenido,
                                diasAsig: resp,
                                preloader: pre
                            })
                        })
                    }}/>
                ))
            )
        }

        let saveAddDias = () => {
            if (boton1.disabled === true) return null;

            let diaIn = document.getElementById("fechaInAdm").value;
            let diaOut = document.getElementById("fechaOutAdm").value;
            let motivo = document.getElementById("motivo").value;

            if (diaIn === "" || diaOut === "") {
                this.setState({ boton1: { icon: "fa fa-plus", text: "Agregar" } })
                toast.error("Debes indicar el rango de fechas primero",{autoClose: 4000});
                return null
            }

            if (motivo === "") {
                this.setState({ boton1: { icon: "fa fa-plus", text: "Agregar" } })
                toast.error("Debes indicar el motivo del dia No Laborable",{autoClose: 4000});
                return null
            }

            this.setState({
                boton1: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                SaveFeriado (diaIn, diaOut, motivo, () => {
                    this.setState({ 
                        boton1: { icon: "fa fa-plus", text: "Agregar",  disabled: false }
                    }, () => {
                        document.getElementById("fechaInAdm").value = "";
                        document.getElementById("fechaOutAdm").value = "";
                        document.getElementById("motivo").value = "";
                        
                        diasDisabled ((resp) => {
                            let contenido = [];
                            for (let i in resp){
                                let date = resp[i].dia.split("/")
                                let addDate = new Date(parseInt(date[2]), (parseInt(date[1]) - 1), parseInt(date[0]))
                                contenido.push(addDate)
                            }
                
                            this.setState({
                                diasDisabled: contenido,
                                diasAsig: resp
                            })
                        })
                    });
                    toast.info("Se han agregado los Dias no Laborables",{autoClose: 4000});
                })
            })
        }

        return(
            <React.Fragment>
                <div className="custom-alert-info">Agregar dia(s) no laborable(s)</div>
                <Row className="custom-mt-10">
                    <Col md={6}>
                        <input className="form-control" placeholder="DD/MM/AAA" disabled id="fechaInAdm" title="Para añadir la fecha haz click en un rango del calendario"/>
                        <div className="text-muted" style={{fontSize:12}}>Desde</div>
                    </Col>
                    <Col md={6}>
                        <input className="form-control" placeholder="DD/MM/AAA" disabled id="fechaOutAdm" title="Para añadir la fecha haz click en un rango del calendario"/>
                        <div className="text-muted" style={{fontSize:12}}>Hasta</div>
                    </Col>
                    <Col md={6} className="custom-mt-10">
                        <input className="form-control" id="motivo" placeholder="Ej.: Vacaciones"/>
                        <div className="text-muted" style={{fontSize:12}}>Motivo</div>
                    </Col>
                    <Col md={6} className="custom-mt-10" align="right">
                        <button className="btn btn-primary" onClick={() => {
                            this.setState({
                                boton1: {
                                    icon: "fa fa-spinner fa-spin",
                                    text: "Espera",
                                    disabled: false
                                }
                            }, () => {
                                saveAddDias()
                            })
                        }} style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                    </Col>
                </Row>
                <div className="custom-alert-info custom-mt-10">Dias no laborables registrados</div>
                <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "35vh", overflowX:"hidden"}}>
                    <Table striped hover bordered style={{marginBottom: 0}}>
                        <tbody>
                        <tr className="custon-back-color">
                            <td align="center" width="30%" style={styles}><strong>Dia</strong></td>
                            <td align="center" colSpan={2} width="70%" style={styles}><strong>Motivo</strong></td>
                        </tr>
                        {diasFeriadosAsig()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )
    }

    render() {
        return (
            <Row className="custom-mt-10">
                <Col md={5}>
                    <div className="custom-alert-info" style={{padding: 5}}>
                        {this.calendario()}
                        <div align="center" className="custom-mt-10" style={{fontSize: 10}}>Si deseas seleccionar <strong>un solo día</strong> haz doble click sobre el</div>
                    </div>
                </Col>
                <Col md={7}>
                    {this.addDias()}
                </Col>
            </Row>
        );
    }
}
 
export default DiasFeriados;


// WEBPACK FOOTER //
// ./src/views/Opciones/DiasFeriados.jsx